import { useState } from "react";
import { Gauge, Inbox, Filter as FunnelIcon, Megaphone, QrCode, Bot, Zap, PhoneCall, Star, Car, Sparkles, Trophy, BarChart3, BellRing } from "lucide-react";
import CeoDashboard from "@/components/admin/marketing/CeoDashboard";
import WeeklySpecialHub from "@/components/admin/marketing/WeeklySpecialHub";
import ClubAdmin from "@/components/admin/marketing/ClubAdmin";
import LeadsInbox from "@/components/admin/marketing/LeadsInbox";
import FunnelView from "@/components/admin/marketing/FunnelView";
import CampaignManager from "@/components/admin/marketing/CampaignManager";
import QrGenerator from "@/components/admin/marketing/QrGenerator";
import UpfirstPanel from "@/components/admin/marketing/UpfirstPanel";
import AutopilotView from "@/components/admin/marketing/AutopilotView";
import AiSalesDashboard from "@/components/admin/marketing/AiSalesDashboard";
import ReputationDashboard from "@/components/admin/marketing/ReputationDashboard";
import FleetProfit from "@/components/admin/marketing/FleetProfit";
import BusinessIntelligence from "@/components/admin/marketing/BusinessIntelligence";
import VehicleAlerts from "@/components/admin/marketing/VehicleAlerts";

const SUBS = [
  { id: "dashboard", label: "CEO Dashboard", icon: Gauge },
  { id: "intelligence", label: "Intelligence", icon: BarChart3 },
  { id: "vehicle-alerts", label: "Vehicle Alerts", icon: BellRing },
  { id: "weekly-special", label: "Weekly Special", icon: Sparkles },
  { id: "drivers-club", label: "Drivers Club", icon: Trophy },
  { id: "ai-sales", label: "AI Sales", icon: PhoneCall },
  { id: "leads", label: "Leads Inbox", icon: Inbox },
  { id: "funnel", label: "Funnel", icon: FunnelIcon },
  { id: "campaigns", label: "Campaigns", icon: Megaphone },
  { id: "qr", label: "QR Codes", icon: QrCode },
  { id: "fleet-profit", label: "Fleet Profit", icon: Car },
  { id: "reputation", label: "Reputation", icon: Star },
  { id: "upfirst", label: "Upfirst AI", icon: Bot },
  { id: "autopilot", label: "Autopilot", icon: Zap },
];

export default function MarketingCenter({ token, onNavigate }) {
  const [sub, setSub] = useState("dashboard");

  return (
    <div data-testid="marketing-center" className="space-y-5">
      <div className="flex flex-wrap gap-2">
        {SUBS.map((s) => (
          <button key={s.id} data-testid={`marketing-sub-${s.id}`} onClick={() => setSub(s.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-semibold transition-colors ${sub === s.id ? "bg-[#F2B705] text-black" : "bg-[#0C0C0C] border border-white/10 text-white/70 hover:text-white"}`}>
            <s.icon size={15} /> {s.label}
          </button>
        ))}
      </div>
      {sub === "dashboard" && <CeoDashboard token={token} />}
      {sub === "intelligence" && <BusinessIntelligence token={token} />}
      {sub === "vehicle-alerts" && <VehicleAlerts token={token} />}
      {sub === "weekly-special" && <WeeklySpecialHub token={token} />}
      {sub === "drivers-club" && <ClubAdmin token={token} />}
      {sub === "ai-sales" && <AiSalesDashboard token={token} />}
      {sub === "leads" && <LeadsInbox token={token} />}
      {sub === "funnel" && <FunnelView token={token} />}
      {sub === "campaigns" && <CampaignManager token={token} />}
      {sub === "qr" && <QrGenerator token={token} />}
      {sub === "fleet-profit" && <FleetProfit token={token} />}
      {sub === "reputation" && <ReputationDashboard token={token} />}
      {sub === "upfirst" && <UpfirstPanel token={token} />}
      {sub === "autopilot" && <AutopilotView token={token} onNavigate={onNavigate} />}
    </div>
  );
}
